import { memo } from 'react';
import { BaseCheckboxFormControl } from '../BaseCheckboxFormControl/BaseCheckboxFormControl';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { GMCheckboxFormControlProps } from '../..';

/**
 * Checkbox styled like a form control. For use outside of a formik
 */
const CheckboxFormControl: GoMotoComponent<GMCheckboxFormControlProps> = memo((props) => {
    return (
        <BaseCheckboxFormControl
            {...props}
        />
    );
});

export default CheckboxFormControl;